import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var LanguageTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(LanguageTransformer, _BaseTransformer);
  var _super = _createSuper(LanguageTransformer);
  function LanguageTransformer() {
    _classCallCheck(this, LanguageTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(LanguageTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        value: data.language_id,
        label: data.label,
        abbr: data.abbr
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return LanguageTransformer;
}(BaseTransformer);